// 分转元
import Vue from 'vue';
import { toFixed } from '@/common/utils';

Vue.filter('fenToYuan', function (value) {
  if (!value || value.length < 1) return '';
  return toFixed(value);
});
